module.exports = __webpack_public_path__ + "img/dod_day12_image_01.67e69428.jpg";